define('uikit/modules/modal',['require','exports','module','underscore','marionette','../mixins/component.mixin','../collections/container','../collections/grid','templates','../channel','../extra/size','../extra/transition','../helper/dom','../definitions/modules/modal'],function(require, exports, module){
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var ContainerView = require('../collections/container');
  var Grid = require('../collections/grid');
  var Templates = require('templates');
  var channel = require('../channel');
  var Size = require('../extra/size');
  var Transition = require('../extra/transition');
  var DOMHelper = require('../helper/dom');
  require('../definitions/modules/modal');

  var DefaultModalHeader = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'header',

    template: Templates.App['modal.header'],

    options: {
      text: ''
    },

    forceUpdate: { text: true }

  });

  var DefaultModalContent = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'content',

    template: Templates.App['modal.content'],

    options: {
      text: '',
      icon: ''
    },

    forceUpdate: { text: true, icon: true }

  });

  var DefaultModalActions = ContainerView.extend({

    className: 'actions',

    addApprove: function(view) {
      view.$el.addClass('ok');
      this.add(view);
      return this;
    },

    addDeny: function(view) {
      view.$el.addClass('cancel');
      this.add(view);
      return this;
    }

  });

  var FluidModalActions = DefaultModalActions.extend({

    template: Templates.App['modal.actions.fluid'],

    ui: {
      buttons: '.buttons'
    },

    updateAttributes: function() {
      var size = this.getOption('size') ? Grid.getSizeClass(this.getOption('size')) : Grid.getSizeClass(this._views.length);
      if (this._previousSize) {
        this.ui.buttons.removeClass(this._previousSize);
      }
      this._previousSize = size;
      this.ui.buttons.addClass(size);
    },

    appendView: function(view) {
      view.inverted = this.getOption('basic');
      this.ui.buttons.append(view.$el);
      return this;
    }

  });

  var Modal = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui modal',

    template: Templates.App['modal'],

    options: {
      closeIcon              : 'close',
      visible                : false,
      allowMultiple          : false,
      closable               : true,
      transition             : 'scale',
      useCSS                 : true,
      buttons                : null,
      fullscreen             : false,
      size                   : '',
      text                   : '',
      basic                  : false,
      actions                : 'default',
      // prevents semantic modal module
      // from refreshing the modal position
      // when the dom tree changes
      disablePositionRefresh : false
    },

    injectInternalViewsSynchronously: true,

    transitionOptionValues: _.values(Transition),
    sizeOptionValues: _.values(Size),
    actionsOptionValues: [
      'default',
      'fluid'
    ],

    forceUpdate: {
      closeIcon: true,
      allowMultiple: true,
      closable: true,
      transition: true,
      useCSS: true,
      text: true,
      actions: true
    },

    events: {
      'keydown .close' : function(ev) {
        if (ev.keyCode == 13) {
          ev.target.click();
        }
      }
    },

    initialize: function(options) {
      ComponentMixin.initialize.apply(this, arguments);

      this.on('change:visible', function() {
        if (this.visible === true && !this.isRendered) {
          this.show({ force: true });
        }
      });


      if (!this.header && this.header !== false) {
        this.header = new DefaultModalHeader({ modal: this });
      }

      if (!this.content) {
        this.content = new DefaultModalContent({ modal: this });
      } else {
        this.content.options.modal = this;
      }

      if (_.isString(this.actions)) {
        var ignoredOptions = ['visible'];
        switch (this.actions) {
          case 'default':
            this.actions = new DefaultModalActions(_.extend({ modal: this,  }, _.omit(this.options, ignoredOptions)));
            break;
          case 'fluid':
            this.actions = new FluidModalActions(_.extend({ modal: this }, _.omit(this.options, ignoredOptions)));
            break;
        }
      }


      this.on('render', this.attachModalOptions);

      if (this.visible === true) {
        this.show({ force: true });
      }
    },

    updateAttributes: function() {
      this
          .addClass('fullscreen', this.getBoolOption('fullscreen'))
          .addClass(this.getOption('size'), this.getBoolOption('size'))
          .addClass('basic', this.getBoolOption('basic'))
          .addClass('standard', !this.getBoolOption('size') && !this.getBoolOption('basic'))
    },

    attachModalOptions: function() {
      var self        = this;

      // Attach elements based on press event, to allow for click and enter key
      this.listenTo(this.actions, 'childview:press', function(btn) {
        var selectors = $.fn.modal.settings.selector,
            el        = btn.$el;

        if (el.is(selectors.approve)) {
          self.triggerMethod('approve', self);
          self.triggerMethod('confirm', self);
        } else if (el.is(selectors.deny)) {
          self.triggerMethod('deny', self);
        }

        self.$el.modal('hide');
      });

      var MutationObserver;
      if (this.getOption('disablePositionRefresh') && ('MutationObserver' in window)) {
        MutationObserver = window.MutationObserver;
        delete window.MutationObserver;
      }

      this
          .$el
          .modal(_.extend({}, this.options, {
            onShow: function() {
              self.triggerMethod('modal:show', self);
            },
            onVisible: function() {
              self.triggerMethod('modal:visible', self);
            },
            onHide: function() {
              self.triggerMethod('modal:hide', self);
            },
            onHidden: function() {
              self.triggerMethod('modal:hidden', self);
            }
          }));

      if (MutationObserver) {
        window.MutationObserver = MutationObserver;
      }
    },

    _show: function() {
      var self = this;

      if (!this.isRendered) { this.render(); }

      _.defer(function() {
        self.$el.modal('show');
      });
    },

    _hide: function() {
      var self = this;

      if (!this.isRendered) { this.render(); }
      
      _.defer(function() {
        self.$el.modal('hide');
      })
    },

    onModalShow: function() {
      var modal = this.$el.get(0);

      $(document.body).on('keydown.modal', function(ev) {
        DOMHelper.stickFocusWithinElement(ev, modal);
      })

      this.visible = true;
    },

    onModalVisible: function() {
      this.visible = true;
    },

    onModalHide: function() {
      $(document.body).off('.modal');

      this.visible = false;
    },

    onModalHidden: function() {
      this.$el.css('margin-top', '0px');
      this.visible = false;
    }

  });

  Modal.DefaultActions = DefaultModalActions;
  Modal.FluidActions   = FluidModalActions;
  Modal.DefaultHeader  = DefaultModalHeader;
  Modal.DefaultContent = DefaultModalContent;

  Modal.SMALL_SIZE = 'small';
  Modal.LARGE_SIZE = 'large';

  channel.reply('modal', function() {
    return Modal;
  });

  module.exports = Modal;
});
